// extracted by mini-css-extract-plugin
module.exports = {"tableHeader":"TableHeader_tableHeader__3cLQF","pageSizeWrapper":"TableHeader_pageSizeWrapper__1BGUN","selectWrapper":"TableHeader_selectWrapper__1DLXk"};